<template>
  <div class="checkout-approved">
    <div class="installment-title" v-apply-theme>
      Escolha um valor de entrada
    </div>
    <DownPaymentList
      id="down-payment-list"
      v-if="downPaymentOptions"
      :loadingValues="downPaymentValueSkeleton"
      :indexSelected="downPaymentIndexSelected"
      @downPaymentChange="onDownpaymentChange"
      :downPaymentOptions="downPaymentOptions"/>
    <div class="installment-title" v-apply-theme>
      Quantidade de parcelas
    </div>
    <InstallmentSelect
      id="installment-select"
      ref="installment-select"
      :indexSelected="installmentIndexSelected"
      v-if="downPaymentSelected"
      @installmentSelect="onInstallmentSelect"
      :installments="downPaymentSelected.options"
    />
    <CheckoutSummary
      v-if="downPaymentSelected"
      :loading="summarySkeleton"
      :downPaymentValue="downPaymentSelected.downPaymentValue"
      :downPaymentPercentage="downPaymentSelected.downPaymentPercentage"
      :totalAmount="installmentSelected && installmentSelected.totalAmount"
      :interestRatePM="installmentSelected && installmentSelected.interestRatePM"
      :cetPA="installmentSelected && installmentSelected.cetPA"
      :oneLineFooter="true"
    />

    <Button
      id="checkout-confirm-button"
      class="primary"
      v-if="confirmButton"
      @click="pay"
      :disabled="summarySkeleton || (typeof installmentIndexSelected !== 'number')">
      {{ confirmText }}
    </Button>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import DownPaymentList from '@/components/common/DownPaymentList.vue';
import InstallmentSelect from '@/components/common/InstallmentSelect.vue';
import Button from '@/components/ui/AppButton.vue';
import { ApplyTheme } from '@/directives/applyTheme';
import CheckoutSummary from '../components/CheckoutSummary.vue';

export default {
  name: 'checkout-approved',
  directives: {
    ApplyTheme,
  },
  computed: {
    ...mapState('checkout', [
      'downPaymentIndexSelected',
      'installmentIndexSelected',
      'downPaymentOptions',
      'summarySkeleton',
      'downPaymentValueSkeleton',
      'config',
      'hasPreCondition',
    ]),
    ...mapGetters('checkout', [
      'downPaymentSelected',
      'installmentSelected',
      'ccbUrl',
    ]),
    confirmText() {
      return (this.config && this.config.confirmText) || 'Pagar parcelado no boleto';
    },
    confirmButton() {
      return (this.config && this.config.confirmButtom) || false;
    },
    showCCBText() {
      return (this.config && this.config.showCCBText) || false;
    },
  },
  methods: {
    ...mapActions('checkout', [
      'setInstallmentIndex',
      'resetLoading',
      'setDownPaymentIndex',
      'pay',
      'emitEvent',
    ]),
    onDownpaymentChange(index) {
      this.setDownPaymentIndex(index);
    },
    onInstallmentSelect(index) {
      this.setInstallmentIndex(index);
    },
  },
  components: {
    DownPaymentList,
    InstallmentSelect,
    CheckoutSummary,
    Button,
  },
  mounted() {
    this.resetLoading();
    if (this.hasPreCondition) {
      this.emitEvent({
        type: 'preapproved',
      });
    } else {
      this.emitEvent({
        type: 'approved',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
#installment-select {
  margin-bottom: 20px;
}

#down-payment-list {
  margin-bottom: 20px;
}

#checkout-confirm-button {
  margin-top: 20px;
  @media (max-width: $md) {
    width: 100%;
    height: 48px;
  }
}

.installment-title, .down-payment-list-title {
  @extend .body-bold;
  margin-bottom: 8px;
  color: var(--gray-600);
  &--vivo {
    font-weight: normal;
  }
}

.ccb-text {
  @extend .x-small-regular;
  margin: 8px 0;
  text-align: center;

  a {
    @extend .primary;
    text-decoration: none;
  }
}
</style>
